import RentalCostCentreApprovalService from "../services/rental-cost-centre-approval-service";
import { IRentalCostCentreApprovalService } from "../types/services/rental-cost-centre-approval-service";

const rentalCostCentreApprovalService: IRentalCostCentreApprovalService =
  new RentalCostCentreApprovalService();

export default rentalCostCentreApprovalService;
